import React from "react";
import { TwoColumn } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";
import { Title, Button } from "react_reusable_components";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";

const MyAccountModalStyle = {
  modalHeader: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
    lineHeight: variables.lineHeightXxlarge,
    marginBottom: 0,
  },
  topSectionContainer: {
    display: variables.dFlex,
    justifyContent: variables.spaceBetween,
    alignItems: variables.alignCenter,
    padding: variables.paddingSmedium,
    paddingBottom: variables.paddingSmall,
  },
  closeIcon: {
    width: variables.iconWidthLarge,
    height: variables.iconHeightLarge,
  },
  unsetAll: { all: variables.unset, cursor: "pointer" },
};

export default function ResetPasswordModalHeader({ onClose }) {
  const intl = useIntl();
  return (
    <TwoColumn
      style={MyAccountModalStyle.topSectionContainer}
      leftSection={
        <Title style={MyAccountModalStyle.modalHeader}>
          {getLocalizedMessage(intl, "account.changePassword")}
        </Title>
      }
      rightSection={
        <Button
          type="text"
          style={MyAccountModalStyle.unsetAll}
          icon={
            <img
              style={MyAccountModalStyle.closeIcon}
              src={"/icons/close.svg"}
              alt="close"
            />
          }
          onClick={onClose}
        />
      }
    />
  );
}
